// extracted by mini-css-extract-plugin
module.exports = {"vBox":"VBox_vBox__1eHBF"};